import React from "react";
import "../GalleryComponent/GalleryComponentCss/ HeadingSection.css";

export default function HeadingSection() {
  return (
    <section className="heading-section-wrapper">
      <h1 className="main-heading">
      गावाच्या प्रगतीचे आणि उपक्रमांचे प्रेरणादायी क्षणचित्र संग्रह
      </h1>
      <p className="sub-heading">
      गावाच्या विकासाची झलक दाखवणारा प्रेरणादायी फोटो संग्रह
      </p>
    </section>
  );
}
